var _ = require('underscore'),
  React = require('react'),
  ClassNames = require('classnames');

var CustomPropTypes = require('../types.jsx'),
  Utils = require('../utils.jsx');

var ProgressTime = React.createClass({
  propTypes: {
    role: React.PropTypes.string.isRequired,
    track: React.PropTypes.number,
    playlist: React.PropTypes.number,
    playlists: CustomPropTypes.PlaylistsType,

    className: CustomPropTypes.ClassNameType
  },
  render: function () {
    if (~this.props.track) {
      var className = Utils.ClassNames('player-track-number', this.props.className);
      return (
        <div className={ClassNames(className)}>
          <span>{this.props.track + 1}</span>
          <span>&nbsp;of&nbsp;</span>
          <span>{this.props.playlists[this.props.playlist].playlist.length}</span>
        </div>
      );
    } else {
      return null;
    }
  }
});

module.exports = ProgressTime;



// WEBPACK FOOTER //
// ./src/app/components/track/number.jsx